import { Box, Grid2, Typography } from '@mui/material'
import Heading from '../../shared/utils/Heading'
import CustomDivider from '../../shared/utils/CustomDivider'
import { EducationForLifeImages } from '../../assets/img/educationforlife/EducationForLifeImages'
import { Page_Padding } from '../../shared/constants'
import { getImageUrl } from '../../shared/utils/getImageUrl'

const borderWithDots = {
    borderLeft: "1px solid #818181",
    p: 2,
    position: "relative",
    "&::before": {
        content: '""',
        width: "10px",
        height: "10px",
        backgroundColor: "#818181",
        borderRadius: "50%",
        position: "absolute",
        left: "-5px",
        top: "-5px",
    },
    "&::after": {
        content: '""',
        width: "10px",
        height: "10px",
        backgroundColor: "#818181",
        borderRadius: "50%",
        position: "absolute",
        left: "-5px",
        bottom: "-5px",
    },
};

const imgStyle = {
    width: "100%",
    objectFit: "cover",
    borderRadius: 0
};

const AboutElyfSection = ({ aboutElyfData }) => {
    const RenderPoints = ({ points, title }) => (
        <>
            <Typography variant='h6' mb={1} dangerouslySetInnerHTML={{ __html: title }} />
            {points.map((txt) => (
                <Typography key={txt} variant="body2" color="grey.400" my={1} dangerouslySetInnerHTML={{ __html: txt }} />

            ))}
        </>
    )
    return (
        <Box>
            <Heading Heading={aboutElyfData?.subheading} SubHeading={aboutElyfData?.heading} center />
            <CustomDivider />

            {/* SECTION ONE */}
            <Grid2 container px={Page_Padding} sx={{ borderBottom: "1px solid #818181" }}>
                <Grid2 size={{ xs: 0, sm: 0.5, md: 1 }} />
                {/* Card 1 */}
                <Grid2 size={{ xs: 6, sm: 4, md: 4 }} sx={borderWithDots}>
                    <Box
                        component={"img"}
                        src={getImageUrl(aboutElyfData?.aboutElyfList?.[0]?.image)}
                        // src={EducationForLifeImages.AboutElyfFrame1}
                        sx={{ ...imgStyle, height: 200 }}
                    />
                    < RenderPoints title={aboutElyfData?.aboutElyfList?.[0]?.title} points={aboutElyfData?.aboutElyfList?.[0]?.points} />
                    {/* <Typography variant='h6' my={2}>Age-Appropriate Learning</Typography>
                    <Typography variant="body2" color="grey.400">
                        Each grade has a clearly defined list of skills and concepts that a child must know.Example: A Grade 1 child must know basic addition, subtraction, number sense, phonics, sentence formation, etc.ELYF ensures these basics are taught systematically and practiced meaningfully
                    </Typography> */}
                </Grid2>

                <Grid2 size={{ xs: 0, sm: 3.5, md: 3 }} />


                {/* Card 2 */}
                <Grid2 size={{ xs: 6, sm: 4, md: 4 }} sx={borderWithDots}>
                    {/* <Typography variant='h6' mb={1}>Bridging Learning Gaps</Typography>
                    <Typography variant="body2" color="grey.400">
                        Many children miss certain basics due to fast-paced schooling. ELYF helps identify gaps and rebuilds learning from the foundation up—at the child’s pace
                    </Typography> */}
                    < RenderPoints title={aboutElyfData?.aboutElyfList?.[1]?.title} points={aboutElyfData?.aboutElyfList?.[1]?.points} />
                    <CustomDivider size="2rem" />
                    <Box
                        component={"img"}
                        src={getImageUrl(aboutElyfData?.aboutElyfList?.[1]?.image)}
                        // src={EducationForLifeImages.AboutElyfFrame2}
                        sx={{ ...imgStyle, height: 220 }}
                    />
                </Grid2>

            </Grid2>

            {/* SECTION TWO */}
            <Grid2 container px={Page_Padding}>

                <Grid2 size={{ xs: 0, sm: 1.5, md: .15 }} />

                {/* Card 3 */}
                <Grid2 size={{ xs: 6, sm: 4, md: 4 }} sx={borderWithDots}>
                    {/* <Typography variant='h6' mb={1}>Foundation-Based Curriculum</Typography>


                    {[" The program is structured around core competencies, not just syllabus completion.We focus on strengthenin", "Foundational Math", "Reading & Comprehension", "Writing Skills",
                        "Logical & Analytical Thinking", "Life Skills & Personality Development"].map((txt) => (
                            <Typography key={txt} variant="body2" color="grey.400" my={1}>
                                {txt}
                            </Typography>
                        ))} */}

                    < RenderPoints title={aboutElyfData?.aboutElyfList?.[2]?.title} points={aboutElyfData?.aboutElyfList?.[2]?.points} />

                    <CustomDivider size="1rem" />

                    <Box
                        component={"img"}
                        // src={EducationForLifeImages.AboutElyfFrame3}
                        src={getImageUrl(aboutElyfData?.aboutElyfList?.[2]?.image)}
                        sx={{ ...imgStyle, height: 200 }}
                    />
                </Grid2>

                <Grid2 size={{ xs: 0, sm: 1, md: 1 }} />

                {/* Card 4 */}
                <Grid2 size={{ xs: 6, sm: 4, md: 4.5 }} sx={borderWithDots}>
                    {/* <Typography variant='h6' mb={1}>Simple, Practical, Easy-to-Follow Lessons</Typography>

                    {[
                        "Every module is broken into child-friendly sessions with",
                        "Step-by-step learning",
                        "Fun activities",
                        "Skill checks",
                        "Reinforcement worksheets",
                        "This ensures children understand, not just memorize",
                    ].map((line) => (
                        <Typography key={line} variant="body2" color="grey.400" my={1}>
                            {line}
                        </Typography>
                    ))} */}

                    < RenderPoints title={aboutElyfData?.aboutElyfList?.[3]?.title} points={aboutElyfData?.aboutElyfList?.[3]?.points} />

                    <CustomDivider size="1rem" />

                    <Box
                        component={"img"}
                        // src={EducationForLifeImages.AboutElyfFrame4}
                          src={getImageUrl(aboutElyfData?.aboutElyfList?.[3]?.image)}
                        sx={{ ...imgStyle, height: 220 }}
                    />
                </Grid2>

            </Grid2>
        </Box>
    )
}

export default AboutElyfSection

